import { Navigate, useLocation } from "react-router-dom";
import Contests from "./Contests";

// The same test the Go handler uses to switch into its old admin view.
export function isAdminSearch(search: string): boolean {
  const q = new URLSearchParams(search);
  return q.get("adminSearch") === "1" || q.get("admin") === "1";
}

// adminTarget is the Control Room with the old admin flag dropped and any
// other parameters kept, as Go's AdminSearchRedirect builds it.
export function adminTarget(search: string): string {
  const q = new URLSearchParams(search);
  q.delete("adminSearch");
  q.delete("admin");
  const rest = q.toString();
  return rest ? `/admin?${rest}` : "/admin";
}

// /contests in the app. The Plush contest admin moved to the Control Room
// (EPIC-012), so an old admin search opens /admin instead.
export default function ContestsRoute() {
  const { search } = useLocation();
  return isAdminSearch(search) ? <Navigate to={adminTarget(search)} replace /> : <Contests />;
}
